import { type JSX } from 'react';
import { cx } from '@linaria/core';

import {
  buttonHide,
  buttonSlideOut,
  LeftButton,
  LeftButtonFadeContainer,
  RightButton,
  RightButtonFadeContainer,
} from './style';

export interface LeftScrollButtonWithFadeProps {
  dataTrack?: string;
  handleScrollLeftClick: () => void;
  isScrollable: boolean;
  leftButtonClass?: string;
  leftButtonHidden: boolean;
}

export interface RightScrollButtonWithFadeProps {
  dataTrack?: string;
  handleScrollRightClick: () => void;
  isScrollable: boolean;
  rightButtonClass?: string;
  rightButtonHidden: boolean;
}

export const LeftScrollButtonWithFade = ({
  dataTrack,
  handleScrollLeftClick,
  isScrollable,
  leftButtonClass = '',
  leftButtonHidden,
}: LeftScrollButtonWithFadeProps): JSX.Element => (
  <LeftButtonFadeContainer
    className={cx(leftButtonClass, leftButtonHidden && buttonSlideOut, !isScrollable && buttonHide)}
  >
    <LeftButton
      data-testid="scrollable-left-button"
      onClick={handleScrollLeftClick}
      {...(dataTrack ? { 'data-track': dataTrack } : {})}
    />
  </LeftButtonFadeContainer>
);

export const RightScrollButtonWithFade = ({
  dataTrack,
  handleScrollRightClick,
  isScrollable,
  rightButtonClass = '',
  rightButtonHidden,
}: RightScrollButtonWithFadeProps): JSX.Element => (
  <RightButtonFadeContainer
    className={cx(rightButtonClass, rightButtonHidden && buttonSlideOut, !isScrollable && buttonHide)}
  >
    <RightButton
      data-testid="scrollable-right-button"
      onClick={handleScrollRightClick}
      {...(dataTrack ? { 'data-track': dataTrack } : {})}
    />
  </RightButtonFadeContainer>
);
